'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var MoreIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<circle cx="16" cy="9" r="2"/><circle cx="9" cy="9" r="2"/><circle cx="2" cy="9" r="2"/>';
    case 'medium':
      return '<circle cx="29" cy="16" r="3"/><circle cx="16" cy="16" r="3"/><circle cx="3" cy="16" r="3"/>';
    case 'large':
      return '<circle cx="37" cy="24" r="3"/><circle cx="24" cy="24" r="3"/><circle cx="11" cy="24" r="3"/>';
    }
  }
});

module.exports = MoreIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/More.jsx
 **/